// @ts-ignore
import { checkIsDefined as _checkIsDefined } from "@my-scoot/exly-react-component-lib/build/cjs/features/Common/modules/DataTypes/utils/nanNullUndef";
import { checkIsDefined as checkIsDefinedType } from "@my-scoot/exly-react-component-lib/build/types/features/Common/modules/DataTypes/utils/nanNullUndef";

export const checkIsDefined: typeof checkIsDefinedType = _checkIsDefined;
